export default __webpack_public_path__ + "static/media/people4.b0a362e6.svg";